import api from './apiService';

export interface ProductOrderItem {
  id: number;
  name: string;
  quantity: number;
  price: number;
  total: number;
}

export interface ProductOrderPayload {
  customerName: string;
  phoneNumber?: string;
  transactionDate: string;
  paymentMethod: string;
  products: ProductOrderItem[];
  totalAmount: number;
}

export interface ProductOrderResponse {
  success: boolean;
  message: string;
  data: {
    success: boolean;
    message: string;
    order_detail: {
      order_number: string;
      customer_id: number;
      customer_name: string;
      customer_phone: string;
      order_type: string;
      transaction_date: string;
      product_items: Array<{
        id: number;
        name: string;
        quantity: number;
        price: number;
        total: number;
      }>;
      status: string;
      created_at: string;
    };
    payment_info: {
      payment_type: string;
      payment_method: string;
      total_amount: number;
      payment_expires_at: string;
      booking_hold_expires_at: string | null;
      invoice_number: string;
      invoice_id: string;
      invoice_url?: string; // Optional field for non-cash payments
      payment_status: string;
    };
  };
}

class ProductOrderService {
  async createProductOrder(
    arenaSlug: string,
    payload: ProductOrderPayload
  ): Promise<ProductOrderResponse> {
    try {
      const response = await api.post<ProductOrderResponse>(
        `arenas/${arenaSlug}/product-orders`,
        payload
      );

      if (response.data.success) {
        console.log('Product order created successfully:', response.data);
        return response.data;
      } else {
        console.error('Failed to create product order:', response.data);
        return {
          success: false,
          message: response.data.message || 'Failed to create product order',
          data: {} as any,
        };
      }
    } catch (error: any) {
      console.error('Error creating product order:', error);

      // Handle different types of errors
      if (error.response?.data?.message) {
        return {
          success: false,
          message: error.response.data.message,
          data: {} as any,
        };
      } else if (error.response?.status === 422) {
        return {
          success: false,
          message: 'Validation error: Please check your input data',
          data: {} as any,
        };
      } else if (error.response?.status === 401) {
        return {
          success: false,
          message: 'Unauthorized: Please login again',
          data: {} as any,
        };
      } else {
        return {
          success: false,
          message: 'Network error: Please try again later',
          data: {} as any,
        };
      }
    }
  }
}

export const productOrderService = new ProductOrderService();
